"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownButtonContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("./Dropdown.styled");
var _Icon = require("../Icon");
var _styles = require("../../shared/styles");
var _OutsideAlerter = _interopRequireDefault(require("../../molecules/OutsideAlerter"));
var _reactDom = require("react-dom");
var _jsxRuntime = require("react/jsx-runtime");
var DropdownButtonContext = exports.DropdownButtonContext = /*#__PURE__*/(0, _react.createContext)(null);
var DropdownButton = function DropdownButton(_ref) {
  var _positionRef$current;
  var children = _ref.children,
    size = _ref.size,
    positionRef = _ref.positionRef,
    _ref$initialVisible = _ref.initialVisible,
    initialVisible = _ref$initialVisible === void 0 ? true : _ref$initialVisible;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    expanded = _ref3[0],
    setExpanded = _ref3[1];
  var _ref4 = (0, _react.useState)(initialVisible),
    _ref5 = _slicedToArray(_ref4, 2),
    visible = _ref5[0],
    setVisible = _ref5[1];
  var _ref6 = (0, _react.useState)(positionRef === null || positionRef === void 0 ? void 0 : (_positionRef$current = positionRef.current) === null || _positionRef$current === void 0 ? void 0 : _positionRef$current.getBoundingClientRect()),
    _ref7 = _slicedToArray(_ref6, 2),
    bounds = _ref7[0],
    setBounds = _ref7[1];
  (0, _react.useEffect)(function () {
    var _positionRef$current2;
    setBounds(positionRef === null || positionRef === void 0 ? void 0 : (_positionRef$current2 = positionRef.current) === null || _positionRef$current2 === void 0 ? void 0 : _positionRef$current2.getBoundingClientRect());
  }, [positionRef]);
  var toggleDropdown = function toggleDropdown() {
    setExpanded(function (prev) {
      return !prev;
    });
  };
  var closeDropdown = function closeDropdown() {
    // Delay for not mixing up with events for icon click
    setTimeout(function () {
      return setExpanded(false);
    }, 10);
  };
  var content = function content(children) {
    return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.DropdownButtonContainer, {
      visible: expanded,
      bounds: bounds,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutsideAlerter.default, {
        callback: closeDropdown,
        enabled: expanded,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownButtonContext.Provider, {
          value: {
            expanded: expanded,
            setExpanded: setExpanded,
            visible: visible,
            setVisible: setVisible
          },
          children: children
        })
      })
    }), document.body);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.DropdownButtonWrapper, {
      size: size,
      expanded: expanded,
      onClick: function onClick() {
        return toggleDropdown();
      },
      className: "dropdownButtonWrapper",
      visible: visible,
      children: expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: _styles.iconSizes.atom[size],
        icon: 'chevronUp'
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: _styles.iconSizes.atom[size],
        icon: 'chevronDown'
      })
    }), content(children)]
  });
};
DropdownButton.defaultProps = {
  size: 'm',
  onSelect: function onSelect(value) {
    return value;
  }
};
var _default = exports.default = DropdownButton;